export default __webpack_public_path__ + "static/media/dots-down.e1221cff.svg";